import './style.css';

import { TextField } from '@material-ui/core';
import { Colors } from 'bz-core-controls/styles/colours';
import cx from 'classnames';
import Field from 'click-controls/controls/form/field';
import createReactClass from 'create-react-class';
import Joi from 'joi';
import _ from 'lodash';
import React from 'react';
import Api from 'tm3-core/api';
import validate from 'validate.js';

import LoadingPanel from '../../../../controls/layout/loading-panel';
import Popover from '../../../../controls/modal/popover';
import Text from '../../../clinical/clinical-text';
import Button from '../../../general/button';
import Chip from './controls/chip';
import type IAutoSuggest from './ts/component';
import type IProps from './ts/props';
import type IState from './ts/state';

export interface IItemTemplateProps {
  text?: React.ReactNode;
  [key: string]: any;
}

export const ItemTemplate: React.FC<IItemTemplateProps> = (props) => {
  return <div>{props.text}</div>;
};

export interface ITokenTemplateProps {
  text?: React.ReactNode;
}

export const TokenTemplate: React.FC<ITokenTemplateProps> = (props) => {
  return <div>{props.text}</div>;
};

export interface IExposed extends React.ClassicComponent<{}> {
  clear: () => void;
}

const AutoSuggest = createReactClass<IProps, IState>({
  displayName: 'AutoSuggest',

  getInitialState(this: IAutoSuggest) {
    this.args = {};
    this.searchDebounced = _.debounce(this.search, 1000);

    const state: Partial<IState> = {
      args: {},
      count: 0,
      filtered: (typeof this.props.src !== 'string' ? this.props.src : null) || [],
      index: 0,
      loading: true,
      open: false,
      selectedItems: [],
      term: this.props.term || ''
    };

    return state as IState;
  },

  getDefaultProps() {
    const props: Partial<IProps> = {
      arguments: {},
      bespokeOnAddFunction: null,
      className: '',
      disabled: false,
      inline: false,
      itemTemplate: ItemTemplate,
      Footer: <span />,
      multi: false,
      placeholder: 'Type to search',
      term: '',
      tokenTemplate: null,
      filter: function (item, term) {
        return item.indexOf(term) >= 0;
      },
      parse: function (res) {
        return res.body.results;
      },
      onRequestResize: Function.NOOP
    };

    return props as IProps;
  },

  UNSAFE_componentWillMount(this: IAutoSuggest) {
    this.setState({
      placeholder: this.props.placeholder,
      selectedItems: this.props.value || []
    });
  },

  componentDidUpdate(this: IAutoSuggest) {
    if (!!this.props.multi && this.props.value !== this.state.selectedItems) {
      this.setState({
        selectedItems: this.props.value || []
      });
    }
  },

  UNSAFE_componentWillReceiveProps(this: IAutoSuggest, nextProps) {
    if (nextProps.term != this.props.term) {
      this.setState({ term: nextProps.term! });
    }
  },

  search(this: IAutoSuggest, add?: boolean) {
    const src = this.props.src as string;

    this.setState({
      loading: true
    });

    if (/^\/api\//.test(src)) {
      const filtered = this.state.filtered;
      Api.post(src, this.state.args)
        .then((res: any) => {
          const { results, total } = res.body;
          const base = (add && filtered) || [];
          this.setState({
            filtered: [...base, ...(results as any[])],
            count: total as number,
            loading: false
          });
          this.props.onRequestResize?.();
        })
        .catch((e) => {
          this.setState({
            loading: false
          });
          throw e;
        });
    } else {
      let action = this.props.onAction(this.props.src, this.state.args);
      if (action !== undefined) {
        this.setState({
          loading: true
        });
        action
          .then((res) => {
            this.setState({
              filtered: res,
              loading: false
            });
            this.props.onRequestResize?.();
          })
          .catch((e) => {
            this.setState({
              loading: false
            });
            throw e;
          });
      } else {
        this.setState({
          loading: false
        });
      }
    }
  },

  onChange(this: IAutoSuggest, e: React.ChangeEvent<HTMLInputElement>) {
    e.preventDefault();

    const { value: term } = e.target;
    let { args } = this.state;

    this.setState({
      loading: true,
      filtered: (typeof this.props.src !== 'string' ? this.props.src : null) || [],
      selectedItems: []
    });

    if (this.props.liveOnChange) {
      this.props.onChange?.(e.target.value);
    }

    if (!this.props.src) {
      this.setState({
        term: e.target.value,
        index: 0,
        placeholder: '',
        loading: true
      });
      return;
    }

    let filtered: string[] = [];

    if (typeof this.props.src === 'string') {
      args = _.extend({}, { term: term }, this.props.arguments);
      //let setArgs = _.extend({}, {term:term}, this.props.arguments)
      if (term !== '') {
        this.searchDebounced();
      }
      this.setState({
        anchorEl: e.target,
        term: e.target.value,
        open: true,
        args
      });

      if (term === '') {
        this.setState({
          term: e.target.value,
          anchorEl: null,
          open: false,
          loading: false,
          filtered: []
        });
      }
      return;
    } else {
      filtered = this.props.src.filter((item) => {
        return this.props.filter(item, term);
      });
    }

    this.setState({
      term: e.target.value,
      anchorEl: e.target,
      open: true,
      index: 0,
      filtered: filtered,
      placeholder: '',
      loading: false
    });
  },

  onKeyDown(this: IAutoSuggest, e: React.KeyboardEvent<HTMLInputElement>) {
    let fnKeys = [13, 188];

    if (this.state.open) {
      fnKeys.push(27);
    }

    if (fnKeys.includes(e.keyCode || e.which)) {
      e.preventDefault();
      e.stopPropagation();
    }

    let index = this.state.index;
    switch (e.keyCode || e.which) {
      case 8:
        if (this.props.term != null && this.props.multi !== true) {
          this.setState({
            placeholder: this.props.placeholder,
            term: e.currentTarget.value
          });
        } else if (this.props.multi) {
          if (e.currentTarget.selectionStart === 0) {
            const wo = this.state.selectedItems.slice(0, -1);
            this.setState({ selectedItems: wo });
            this.props.onChange?.(wo);
          }
        }
        break;

      case 27:
        index = 0;
        this.setState({ term: '', open: false });
        break;

      case 38:
        index -= index > 0 ? 1 : 0;
        break;

      case 40:
        index += index < this.state.filtered.length ? 1 : 0;
        break;

      case 13:
      case 188:
        const { bespokeOnAddFunction, multi } = this.props;
        if (index < 1 && this.props.multi && e.currentTarget.value.length > 0) {
          !bespokeOnAddFunction ? this.addEmail(e) : bespokeOnAddFunction(e);
        } else {
          this.onSelected(this.state.filtered[index - 1]);
        }
        break;

      //possible extension for tabbing
      default:
        break;
    }

    this.setState({ index: index });
  },

  onSelected(this: IAutoSuggest, item: any, e?: React.MouseEvent) {
    if (BzNotNull(e)) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (!item) {
      return;
    }

    this.state.selectedItems.push(item);
    if (this.props.multi) {
      this.props.onChange?.(this.state.selectedItems);
      this.setState({ term: '', open: false });
      // commented this as when email is selected it leaves the search string
      // if it causes problems please talk to me. SC
      // this.setState({ term: item[this.props.displayName], open: false });
    } else if (this.props.displayName) {
      this.props.onChange?.(item);
      this.setState({ term: item[this.props.displayName], open: false });
    } else {
      this.props.onChange?.(item);
      if (!this.props.hideSelection) {
        this.setState({ term: item, open: false });
      } else {
        this.setState({ open: false });
      }
    }
  },

  clear(this: IAutoSuggest) {
    this.setState({ term: '' });
  },

  onClose(this: IAutoSuggest) {
    this.setState({ open: false, anchorEl: null });
  },

  addEmail(
    this: IAutoSuggest,
    e: React.FocusEvent<HTMLInputElement> | React.KeyboardEvent<HTMLInputElement>
  ) {
    const { value } = e.currentTarget;
    const err = validate.single(value, { email: true });
    if (err) {
      return;
    }

    const item = { email: e.currentTarget.value };
    this.state.selectedItems.push(item);
    this.props.onChange?.(this.state.selectedItems);
    this.setState({
      term: '',
      open: false
    });
  },

  onBlur(this: IAutoSuggest, e: React.FocusEvent<HTMLInputElement>) {
    this.addEmail(e);
    this.props.onBlur?.();
  },

  removeToken(this: IAutoSuggest, token: any) {
    const wo = this.state.selectedItems.filter((x) => x !== token);
    this.setState({ selectedItems: wo });
    this.props.onChange?.(wo);
  },

  getMoreClients(this: IAutoSuggest) {
    const { args } = this.state;
    args.startIdx += 25;
    args.endIdx += 25;
    this.setState({
      args
    });

    this.search(true);
  },

  render(this: IAutoSuggest) {
    let content;
    let style: React.CSSProperties = Object.assign(
      {},
      {
        padding: 0,
        minWidth: '200px',
        maxHeight: '500px'
      },
      this.props.dropdownStyle
    );

    const itemHeight = this.props.itemHeight ? this.props.itemHeight : 30;
    const footerHeight = this.props.footerHeight ? this.props.footerHeight : 0;

    const dropdownStyle = Object.assign(
      {},
      {
        backgroundColor: 'whitesmoke',
        padding: !this.state.open ? '0px' : '2px 0px 0px 0px',
        borderLeft: 'solid 1px #ccc',
        borderRight: 'solid 1px #ccc',
        borderBottom: !this.state.open ? 'none' : 'solid 1px #ccc',
        minWidth: '200px',
        transition: 'all 0.5s ease-in',
        height: this.state.open
          ? this.state.loading
            ? '130px'
            : this.state.filtered.length < 1
              ? '31px'
              : itemHeight * this.state.filtered.length + footerHeight + 'px'
          : 0,
        marginBottom: '10px',
        overflow: 'hidden',
        maxHeight: 312,
        overflowY: 'auto'
      },
      this.props.dropdownStyle
    );

    let containerStyle = Object.assign(
      {},
      {
        border: '1px solid #eee',
        padding: '5px',
        width: '100%',
        display: '-webkit-flex',
        marginBottom: '10px'
      },
      this.props.style
    );

    const selectedItems = this.state.selectedItems.map((x, i) => {
      const tokenTemplate = this.props.tokenTemplate || Chip;
      return (
        <div className="tokenStyle" key={i}>
          {React.createElement(
            tokenTemplate,
            typeof x === 'string'
              ? { text: x, disabled: this.props.disabled }
              : _.extend(x, {
                  removeToken: this.removeToken.bind(this, x),
                  disabled: this.props.disabled
                })
          )}
        </div>
      );
    });

    if (this.state.filtered.length < 1 && this.state.open && !this.state.loading) {
      style = this.props.inline ? { padding: 5 } : {};
      content = [
        <li key="no-items">
          <div style={style}>No Results Found</div>
        </li>
      ];
    } else {
      content = this.state.filtered.map((data, i) => {
        return (
          <li
            key={i}
            className={cx({ selected: this.state.index == i + 1 })}
            onClick={this.onSelected.bind(this, data)}
          >
            {React.createElement(
              this.props.itemTemplate!,
              typeof data === 'string' ? { text: data } : data
            )}
          </li>
        );
      });
    }

    if (this.props.showLoadMore && this.state.count === 25) {
      content.push(
        <li>
          <Button primary={true} onClick={this.getMoreClients} style={{ width: '100%' }}>
            Load More
          </Button>
        </li>
      );
    }

    let dropdown;
    if (this.props.inline) {
      dropdown = (
        <div className="auto-suggest-dropdown auto-suggest-inline" style={dropdownStyle}>
          <LoadingPanel loading={this.state.loading} size={1.5}>
            <ul>{content}</ul>
            <div>{this.props.children}</div>
          </LoadingPanel>
        </div>
      );
    } else {
      dropdown = (
        <Popover
          style={style}
          anchorEl={this.state.anchorEl}
          autoCloseWhenOffScreen={this.props.autoCloseWhenOffScreen}
          disableAutoFocus={true}
          disableEnforceFocus={true}
          open={this.state.open}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          onRequestClose={this.onClose}
        >
          <LoadingPanel
            loading={this.state.loading}
            className="auto-suggest-dropdown"
            style={{ minWidth: 250 }}
            size={1.5}
          >
            <ul>{content}</ul>
            <div>{this.props.children}</div>
          </LoadingPanel>
        </Popover>
      );
    }

    if (this.props.multi) {
      return (
        <div className={`bz-auto-suggest ${this.props.className}`} style={containerStyle}>
          <span style={{ marginRight: '10px', paddingTop: '5px' }}>{this.props.label}</span>
          <div style={{ display: 'inline-block' }}>{!!this.props.multi ? selectedItems : null}</div>
          <input
            className="bz-auto-suggest-input"
            style={{
              border: 'none',
              outline: 'none',
              width: '100%',
              minWidth: '220px',
              padding: '6px'
            }}
            onChange={this.onChange}
            onKeyDown={this.onKeyDown}
            onFocus={this.props.onFocus}
            onBlur={this.onBlur}
            value={this.state.term}
            disabled={this.props.disabled}
          />
          <span style={{ color: Colors.red900, paddingTop: 8 }}>{this.props.errorText}</span>
          <Popover
            style={style}
            anchorEl={this.state.anchorEl}
            open={this.state.open}
            disableAutoFocus={true}
            disableEnforceFocus={true}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left'
            }}
            onRequestClose={this.onClose}
            autoCloseWhenOffScreen={this.props.autoCloseWhenOffScreen}
          >
            <LoadingPanel
              loading={this.state.loading}
              className="auto-suggest-dropdown"
              style={{ minHeight: 300, minWidth: 250 }}
              size={1.5}
            >
              <ul>{content}</ul>
              <div>{this.props.children}</div>
            </LoadingPanel>
          </Popover>
        </div>
      );
    } else {
      if (!this.props.clinicalText) {
        if (!!process.env.isClick) {
          return (
            <div>
              <Field
                autoFocus={this.props.autoFocus}
                fullWidth={true}
                autoCorrect="off"
                autoCapitalize="off"
                value={this.state.term}
                onChange={this.onChange}
                onBlur={this.props.onBlur}
                onKeyDown={this.onKeyDown}
                onFocus={this.props.onFocus}
                disabled={this.props.disabled}
                placeholder={this.state.placeholder}
                label={this.props.label}
              />
              {dropdown}
            </div>
          );
        }

        return (
          <div className={`bz-auto-suggest ${this.props.className}`} style={this.props.style}>
            <TextField
              autoCapitalize="off"
              autoCorrect="off"
              autoFocus={this.props.autoFocus}
              disabled={this.props.disabled}
              fullWidth={true}
              label={this.props.label}
              placeholder={this.state.placeholder}
              value={this.state.term}
              onChange={this.onChange}
              onBlur={this.props.onBlur}
              onFocus={this.props.onFocus}
              onKeyDown={this.onKeyDown}
            />
            <div style={{ display: 'inline-block' }}>
              {this.props.multi == true ? selectedItems : null}
            </div>
            {dropdown}
          </div>
        );
      }

      return (
        <div className={`bz-auto-suggest ${this.props.className}`} style={this.props.style}>
          <Text
            autoCapitalize="off"
            autoCorrect="off"
            autosuggest={true}
            disabled={this.props.disabled}
            fullWidth={true}
            label={this.props.label}
            liveOnChange={this.props.liveOnChange}
            placeholder={this.state.placeholder}
            value={this.state.term}
            onBlur={this.props.onBlur}
            onChange={this.onChange}
            onFocus={this.props.onFocus}
            onKeyDown={this.onKeyDown}
          />
          <div style={{ display: 'inline' }}>{!!this.props.multi ? selectedItems : null}</div>
          {dropdown}
        </div>
      );
    }
  }
});

export default AutoSuggest;
